'use strict';

module.exports = caseSensitiveTransform;
function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute;
}